"use client";

import Link from "next/link";
import Image from "next/image";
import { useTheme } from "@/contexts/ThemeContext";
import { urlFor } from "@/sanity/lib/image";
import { SITE_SETTINGS_QUERYResult } from "@/sanity/types";

export function Header({
  siteSettings,
}: {
  siteSettings: SITE_SETTINGS_QUERYResult | null;
}) {
  const { themeColors } = useTheme();

  const renderLogo = () => {
    if (siteSettings?.logo?.asset) {
      const imageUrl = urlFor(siteSettings.logo).height(180).url();
      return (
        <Image
          src={imageUrl}
          alt={siteSettings.logo.alt || siteSettings.siteName || "Logo"}
          height={60}
          width={180}
          className="object-contain"
        />
      );
    }
    return (
      <span className={`${themeColors.logoColor} tracking-tight`}>
        {siteSettings?.siteName || "ENDIVE CHAOS"}
      </span>
    );
  };

  return (
    <div className="site-header bg-transparent">
      <header className=" flex items-center justify-between shadow-black-50">
        <Link href="/">{renderLogo()}</Link>
        {/* <ul className="flex items-center gap-4 font-semibold text-slate-700">
          <li>
            <Link
              className="hover:text-blue-500 transition-colors"
              href="/posts"
            >
              Posts
            </Link>
          </li>
          <li>
            <Link
              className="hover:text-blue-500 transition-colors"
              href="/studio"
            >
              Sanity Studio
            </Link>
          </li>
        </ul> */}
      </header>
    </div>
  );
}
